function getNewWaitCount(waitCount, inc) {
    if (inc < 0 && waitCount <= 1) {
        return 0;
    }
    return waitCount + inc;
}

function increasedWaitCount(waitCount) {
    return getNewWaitCount(waitCount, 1);
}

function decreasedWaitCount(waitCount) {
    return getNewWaitCount(waitCount, -1);
}

export const initialLoaderState = {
    waitCount: 0,
    show: false
};

// reducer for everything that's loader related
export default function loaderReducer(state = initialLoaderState, action = {type: ''}) {
    if (action.type === 'SHOW_LOADER') {
        const newWaitCount = increasedWaitCount(state.waitCount);
        return {
            ...state,
            waitCount: newWaitCount,
            show: newWaitCount > 0
        };
    } else if (action.type === 'HIDE_LOADER') {
        const newWaitCount = decreasedWaitCount(state.waitCount);
        return {
            ...state,
            waitCount: newWaitCount,
            show: newWaitCount > 0
        };
    }

    return state;
}
